import { Component } from "react";
import { Link } from "react-router-dom";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info);
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-bgDark flex flex-col items-center justify-center text-center px-4">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-neonRed rounded-full blur-3xl opacity-10 animate-pulse" />
          <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-neonPurple rounded-full blur-3xl opacity-10 animate-pulse" />
        </div>
        <div className="relative z-10 space-y-5 max-w-sm">
          <div className="mx-auto w-20 h-20 rounded-full border-2 border-neonRed flex items-center justify-center">
            <span className="text-3xl text-neonRed">✕</span>
          </div>
          <h1 className="text-3xl font-black">
            <span className="text-neonRed">Algo salió</span>{" "}
            <span className="text-white">mal</span>
          </h1>
          <p className="text-textSoft text-sm">
            Ocurrió un error inesperado. Tu sesión y datos están seguros.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-6 py-2 rounded-lg border-2 border-neonPurple text-neonPurple font-bold text-sm hover:shadow-neon-purple transition-all"
            >
              Reintentar
            </button>
            <Link to="/">
              <button className="px-6 py-2 rounded-lg border border-white/20 text-textSoft font-bold text-sm hover:text-white transition-all">
                Ir al inicio
              </button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
